<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col md="3" sm="12" style="text-align: center">
        <v-calendar
          :attributes="attributes"
          :theme-styles="themeStyles"
          @update:page="monthScroll"
          @dayclick="dayClick"
          is-expanded
        ></v-calendar>
      </b-col>
      <b-col md="9" sm="12">
        <c-table
          small
          :caption="tableCaption"
          :tableType="'dashboard'"
          :reserves="detailedSelectedDayReserves"
          @row-clicked="onRowClick"
          @dashboard-enabled-toggled="initialLoad"
        ></c-table>
      </b-col>
      <div v-show="loadingMonth || loadingDay" class="loading"></div>
    </b-row>
    <EditReserve
      v-if="editReserveModal"
      @hidden="editReserveModal = false"
      @edited="editedReserve"
      @error="editReserveError"
      :reserveID="editReserve.id"
    ></EditReserve>
  </div>
</template>

<script>
import Vue from "vue";
import VCalendar from "v-calendar";
import "v-calendar/lib/v-calendar.min.css";
import moment from "moment";
import api from "../api";
import config from "../config";
import cTable from "./Table.vue";
import EditReserve from "./reserves/EditReserve.vue";

import VueNotifications from "vue-notifications";
import miniToastr from "mini-toastr"; // https://github.com/se-panfilov/mini-toastr

const toastTypes = {
  success: "success",
  error: "error",
  info: "info",
  warn: "warn"
};

miniToastr.init({ types: toastTypes });

miniToastr.setIcon("success", "i", { class: "fa fa-check-circle-o" });

function toast({ title, message, type, timeout, cb }) {
  return miniToastr[type](message, title, timeout, cb);
}

const options = {
  success: toast,
  error: toast,
  info: toast,
  warn: toast
};

Vue.use(VueNotifications, options);

Vue.use(VCalendar, {
  firstDayOfWeek: 2,
  formats: {
    title: "MMMM YYYY",
    weekdays: "W",
    navMonths: "MMM",
    input: ["DD/MM/YYYY"],
    dayPopover: "L",
    data: ["L", "YYYY-MM-DD", "YYYY/MM/DD"]
  },
  popoverVisibility: "focus"
});

export default {
  name: "dashboard",
  components: {
    cTable,
    EditReserve
  },
  data: function() {
    return {
      loadingMonth: true,
      loadingDay: true,
      selectedDate: new Date(),
      monthReserves: [],
      detailedSelectedDayReserves: [],
      dayReserves: [],
      editReserveModal: false,
      editReserve: {
        id: null
      },
      attributes: [
        {
          dot: {
            backgroundColor: "green" // Red dot
          },
          dates: []
        },
        {
          dot: {
            backgroundColor: "orange" // Turquoise dot
          },
          dates: []
        },
        {
          dot: {
            backgroundColor: "red" // Purple dot
          },
          dates: []
        },
        {
          highlight: {
            backgroundColor: "#66b3cc", // Turquoise background
            borderColor: "#53a9c6",
            borderWidth: "2px",
            borderRadius: "5px"
          },
          contentStyle: {
            color: "white" // White text
          },
          dates: [new Date()]
        }
      ],
      themeStyles: {
        dayCellNotInMonth: {
          opacity: 0,
          pointerEvents: "none",
          display: "none"
        }
      }
    };
  },
  computed: {
    tableCaption() {
      return `<i class='icon-book-open'></i> Reserves - ${moment(
        this.selectedDate
      ).format("DD/MM/YYYY")}`;
    }
  },
  methods: {
    getMonthReserves: async function(year, month) {
      this.loadingMonth = true;
      this.attributes[0].dates = [];
      this.attributes[1].dates = [];
      this.attributes[2].dates = [];
      let dateBegin =
        moment(new Date(year, month, 1)).format("DD-MM-YYYY") + " 00:00:00";
      let dateEnd =
        moment(new Date(year, month + 1, 0)).format("DD-MM-YYYY") + " 23:59:59";
      console.log(dateBegin + " - " + dateEnd);
      let enabled = null
      if (localStorage.dashboardEnabled === 'true') enabled = true
      else if (localStorage.dashboardEnabled === 'false') enabled = false
      return api
        .request("get", config.serverURI + "calendar/reserves", null, {
          dateBegin: dateBegin,
          dateEnd: dateEnd,
          enabled: enabled
        })
        .then(response => {
          console.log(response.data);
          this.monthReserves = response.data;
          response.data.forEach((day, index) => {
            if (day.checkin.length > 0)
              this.attributes[0].dates.push(new Date(year, month, index + 1));
            if (day.ongoing.length > 0)
              this.attributes[1].dates.push(new Date(year, month, index + 1));
            if (day.checkout.length > 0)
              this.attributes[2].dates.push(new Date(year, month, index + 1));
          });
          this.loadingMonth = false;
        })
        .catch(error => {
          console.log(error.response.data);
          this.loadingMonth = false;
        });
    },
    getDayReservesDetails: async function(day) {
      this.loadingDay = true;
      this.detailedSelectedDayReserves = [];
      this.dayReserves = [];
      this.monthReserves[day - 1].checkin.forEach(id => {
        this.dayReserves.push({ id: id, status: "Check-in" });
      });
      this.monthReserves[day - 1].ongoing.forEach(id => {
        this.dayReserves.push({ id: id, status: "Ongoing" });
      });
      this.monthReserves[day - 1].checkout.forEach(id => {
        this.dayReserves.push({ id: id, status: "Check-out" });
      });
      if (this.dayReserves) {
        let reservesParams = "";
        this.dayReserves.forEach(reserve => {
          reservesParams += `${reserve.id},`;
        });
        reservesParams = reservesParams.slice(0, -1);
        api
          .request("get", config.serverURI + "reserves/" + reservesParams)
          .then(response => {
            let reserves = response.data;
            reserves.forEach(reserve => {
              reserve.status = this.dayReserves.find(
                tempReserve => tempReserve.id === reserve.id
              ).status;
              // this.detailedSelectedDayReserves.push(reserve);
            });
            this.detailedSelectedDayReserves = reserves;
            this.loadingDay = false;
          })
          .catch(error => {
            this.loadingDay = false;
            console.log(error);
          });
      }
    },
    monthScroll: function(event) {
      this.getMonthReserves(event.year, event.month - 1);
    },
    dayClick: function(event) {
      this.selectedDate = new Date(event.year, event.month - 1, event.day);
      this.attributes[3].dates = [this.selectedDate];
      this.getDayReservesDetails(event.day);
    },
    initialLoad: async function() {
      await this.getMonthReserves(
        this.selectedDate.getFullYear(),
        this.selectedDate.getMonth()
      );
      console.log(this.selectedDate.getDate());
      await this.getDayReservesDetails(this.selectedDate.getDate());
    },
    onRowClick: function(event) {
      //TODO
      console.log(event);
      this.editReserve.id = event.id;
      this.editReserveModal = true;
    },
    editedReserve: function(client) {
      miniToastr.success(
        "Reserve " + this.editReserve.id + " was edited successfully",
        "Reserve edited!"
      );
      this.initialLoad(); //force reserve list update
    },
    editReserveError: function(event) {
      miniToastr.warn("Unable to edit reserve " + this.editReserve.id);
    }
  },
  mounted: function() {
    this.initialLoad();
  },
  beforeCreate: function() {
    if (localStorage.dashboardEnabled === undefined) localStorage.dashboardEnabled = true
  }
};
</script>

<style>
/* Absolute Center Spinner */
.loading {
  position: fixed;
  z-index: 999;
  height: 2em;
  width: 2em;
  overflow: visible;
  margin: auto;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
}

/* Transparent Overlay */
.loading:before {
  content: "";
  display: block;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.3);
}

/* :not(:required) hides these rules from IE9 and below */
.loading:not(:required) {
  /* hide "loading..." text */
  font: 0/0 a;
  color: transparent;
  text-shadow: none;
  background-color: transparent;
  border: 0;
}

.loading:not(:required):after {
  content: "";
  display: block;
  font-size: 10px;
  width: 1em;
  height: 1em;
  margin-top: -0.5em;
  -webkit-animation: spinner 1500ms infinite linear;
  -moz-animation: spinner 1500ms infinite linear;
  -ms-animation: spinner 1500ms infinite linear;
  -o-animation: spinner 1500ms infinite linear;
  animation: spinner 1500ms infinite linear;
  border-radius: 0.5em;
  -webkit-box-shadow: rgba(0, 0, 0, 0.75) 1.5em 0 0 0,
    rgba(0, 0, 0, 0.75) 1.1em 1.1em 0 0, rgba(0, 0, 0, 0.75) 0 1.5em 0 0,
    rgba(0, 0, 0, 0.75) -1.1em 1.1em 0 0, rgba(0, 0, 0, 0.5) -1.5em 0 0 0,
    rgba(0, 0, 0, 0.5) -1.1em -1.1em 0 0, rgba(0, 0, 0, 0.75) 0 -1.5em 0 0,
    rgba(0, 0, 0, 0.75) 1.1em -1.1em 0 0;
  box-shadow: rgba(0, 0, 0, 0.75) 1.5em 0 0 0,
    rgba(0, 0, 0, 0.75) 1.1em 1.1em 0 0, rgba(0, 0, 0, 0.75) 0 1.5em 0 0,
    rgba(0, 0, 0, 0.75) -1.1em 1.1em 0 0, rgba(0, 0, 0, 0.75) -1.5em 0 0 0,
    rgba(0, 0, 0, 0.75) -1.1em -1.1em 0 0, rgba(0, 0, 0, 0.75) 0 -1.5em 0 0,
    rgba(0, 0, 0, 0.75) 1.1em -1.1em 0 0;
}

/* Animation */

@-webkit-keyframes spinner {
  0% {
    -webkit-transform: rotate(0deg);
    -moz-transform: rotate(0deg);
    -ms-transform: rotate(0deg);
    -o-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    -moz-transform: rotate(360deg);
    -ms-transform: rotate(360deg);
    -o-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@-moz-keyframes spinner {
  0% {
    -webkit-transform: rotate(0deg);
    -moz-transform: rotate(0deg);
    -ms-transform: rotate(0deg);
    -o-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    -moz-transform: rotate(360deg);
    -ms-transform: rotate(360deg);
    -o-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@-o-keyframes spinner {
  0% {
    -webkit-transform: rotate(0deg);
    -moz-transform: rotate(0deg);
    -ms-transform: rotate(0deg);
    -o-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    -moz-transform: rotate(360deg);
    -ms-transform: rotate(360deg);
    -o-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@keyframes spinner {
  0% {
    -webkit-transform: rotate(0deg);
    -moz-transform: rotate(0deg);
    -ms-transform: rotate(0deg);
    -o-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    -moz-transform: rotate(360deg);
    -ms-transform: rotate(360deg);
    -o-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>